import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function LoginModal() {
  const { register, handleSubmit, errors } = useForm();
  const { isAuthenticated, userLogin, isLoading } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [userType, setUserType] = useState("seeker");

  useEffect(() => {
    if (isAuthenticated) {
      $("#sign_up_popup2").modal("hide");
    }
  }, [isAuthenticated]);

  const onSubmit = async (value) => {
    await userLogin(value);
  };

  return (
    <div
      className="modal fade"
      id="sign_up_popup2"
      aria-hidden="true"
      aria-labelledby="sign_up_popupLabel2"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content border-0 overflow-hidden" 
             style={{ borderRadius: "16px" }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-0">

              {/* ===== LEFT SIDE - Image Panel ===== */}
              <div
                className="col-md-5 d-none d-md-flex flex-column align-items-center 
                            justify-content-center p-4 text-white"
                style={{
                  background: "linear-gradient(135deg, #1a73e8 0%, #6c63ff 100%)",
                  minHeight: "550px",
                }}
              >
                <div className="text-center">
                  <img
                    src="/assets/images/login-illustration.svg"
                    alt="Login"
                    className="img-fluid mb-4"
                    style={{ maxHeight: "250px" }}
                  />
                  <h4 className="fw-bold text-white mb-2">Welcome Back!</h4>
                  <p className="text-white-50 small px-3">
                    Login and get access to all the features of Nokari Job
                  </p>
                </div>
              </div>

              {/* ===== RIGHT SIDE - Form Panel ===== */}
              <div className="col-md-7 bg-white p-4 p-md-5 position-relative">

                {/* Close Button */}
                <button
                  type="button"
                  className="btn-close position-absolute"
                  style={{ top: "16px", right: "16px" }}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />

                {/* Header */}
                <div className="mb-4">
                  <h2
                    className="modal-title fw-bold mb-1"
                    id="sign_up_popupLabel2"
                    style={{ color: "#1a1a2e", fontSize: "24px" }}
                  >
                    Sign In
                  </h2>
                  <p className="text-muted small mb-0">
                    Access your Nokari Job account
                  </p>
                </div>

                {/* ===== User Type Toggle ===== */}
                <div className="mb-4">
                  <div
                    className="d-flex rounded overflow-hidden border"
                    style={{ borderColor: "#1a73e8 !important" }}
                  >
                    <label
                      className="flex-fill text-center py-2 m-0 cursor-pointer"
                      style={{
                        background: userType === "seeker" ? "#1a73e8" : "#fff",
                        color: userType === "seeker" ? "#fff" : "#555",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        fontWeight: userType === "seeker" ? "600" : "400",
                        fontSize: "14px",
                      }}
                    >
                      <input
                        type="radio"
                        name="type"
                        value="seeker"
                        className="d-none"
                        defaultChecked
                        ref={register()}
                        onChange={() => setUserType("seeker")}
                      />
                      <i className="ri-user-line me-2"></i>
                      Job Seeker
                    </label>

                    <label
                      className="flex-fill text-center py-2 m-0 cursor-pointer border-start"
                      style={{
                        background: userType === "employer" ? "#1a73e8" : "#fff",
                        color: userType === "employer" ? "#fff" : "#555",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        fontWeight: userType === "employer" ? "600" : "400",
                        fontSize: "14px",
                      }}
                    >
                      <input
                        type="radio"
                        name="type"
                        value="employer"
                        className="d-none"
                        ref={register()}
                        onChange={() => setUserType("employer")}
                      />
                      <i className="ri-building-line me-2"></i>
                      Employer
                    </label>
                  </div>
                </div>

                {/* ===== Form Fields ===== */}
                <div className="row g-3">

                  {/* Email Field */}
                  <div className="col-12">
                    <label className="form-label fw-semibold small text-dark">
                      Email Address
                    </label>
                    <input
                      name="email"
                      type="email"
                      placeholder="Enter your email"
                      className={`form-control form-control-lg ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      style={{
                        borderRadius: "8px",
                        fontSize: "14px",
                        border: "1.5px solid #dee2e6",
                        padding: "10px 14px",
                      }}
                      ref={register({
                        required: "Email field is required.",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                      })}
                    />
                    {errors.email && (
                      <div className="invalid-feedback">
                        {errors.email.message}
                      </div>
                    )}
                  </div>

                  {/* Password Field */}
                  <div className="col-12">
                    <label className="form-label fw-semibold small text-dark">
                      Password
                    </label>
                    <div className="position-relative">
                      <input
                        name="password"
                        type={showPassword ? "text" : "password"}
                        id="login-password"
                        placeholder="Enter your password"
                        className={`form-control form-control-lg ${
                          errors.password ? "is-invalid" : ""
                        }`}
                        style={{
                          borderRadius: "8px",
                          fontSize: "14px",
                          border: "1.5px solid #dee2e6",
                          padding: "10px 42px 10px 14px",
                        }}
                        ref={register({
                          required: "Password field is required",
                        })}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="btn btn-link position-absolute p-0"
                        style={{
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#888",
                          zIndex: 10,
                        }}
                      >
                        <i
                          className={
                            showPassword ? "ri-eye-off-fill" : "ri-eye-fill"
                          }
                          style={{ fontSize: "18px" }}
                        ></i>
                      </button>
                      {errors.password && (
                        <div className="invalid-feedback">
                          {errors.password.message}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Remember Me & Forgot Password */}
                  <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="form-check mb-0">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="remember_me"
                          name="remember"
                          style={{ cursor: "pointer" }}
                        />
                        <label
                          className="form-check-label small text-muted"
                          htmlFor="remember_me"
                          style={{ cursor: "pointer" }}
                        >
                          Remember me
                        </label>
                      </div>
                      <Link
                        to="/forgot_password"
                        className="small fw-semibold text-decoration-none"
                        style={{ color: "#1a73e8" }}
                        onClick={() => {
                          $("#sign_up_popup2").modal("hide");
                        }}
                      >
                        Forgot Password?
                      </Link>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="col-12 mt-2">
                    <button
                      type="submit"
                      className="btn w-100 py-3 fw-bold text-white"
                      disabled={isLoading}
                      style={{
                        background: "linear-gradient(135deg, #1a73e8, #6c63ff)",
                        borderRadius: "8px",
                        fontSize: "15px",
                        border: "none",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {isLoading ? (
                        <div>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          />
                          Logging in...
                        </div>
                      ) : (
                        <div>
                          <i className="ri-login-circle-line me-2"></i>
                          Log In
                        </div>
                      )}
                    </button>
                  </div>

                  {/* Social Login Divider */}
                  <div className="col-12">
                    <div className="d-flex align-items-center gap-3 my-1">
                      <hr className="flex-fill m-0" />
                      <span className="text-muted small">OR Login Via</span>
                      <hr className="flex-fill m-0" />
                    </div>
                  </div>

                  {/* Social Login Buttons */}
                  <div className="col-12">
                    <div className="d-flex justify-content-center gap-3">
                      <button
                        type="button"
                        className="btn btn-outline-secondary rounded-circle d-flex 
                                   align-items-center justify-content-center"
                        style={{ width: "44px", height: "44px" }}
                        title="Login with Google"
                      >
                        <i
                          className="ri-google-fill"
                          style={{ color: "#DB4437", fontSize: "18px" }}
                        ></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary rounded-circle d-flex 
                                   align-items-center justify-content-center"
                        style={{ width: "44px", height: "44px" }}
                        title="Login with Facebook"
                      >
                        <i
                          className="ri-facebook-fill"
                          style={{ color: "#1877F2", fontSize: "18px" }}
                        ></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary rounded-circle d-flex 
                                   align-items-center justify-content-center"
                        style={{ width: "44px", height: "44px" }}
                        title="Login with LinkedIn"
                      >
                        <i
                          className="ri-linkedin-fill"
                          style={{ color: "#0A66C2", fontSize: "18px" }}
                        ></i>
                      </button>
                    </div>
                  </div>

                  {/* Sign Up Link */}
                  <div className="col-12 text-center pb-2">
                    <span className="text-muted small">
                      New to Nokari Job?{" "}
                    </span>
                    <button
                      type="button"
                      className="btn btn-link p-0 small fw-bold text-decoration-none"
                      style={{ color: "#1a73e8" }}
                      data-bs-target="#sign_up_popup"
                      data-bs-toggle="modal"
                      data-bs-dismiss="modal"
                    >
                      Register Now
                    </button>
                  </div>

                </div>
                {/* ===== END Form Fields ===== */}

              </div>
              {/* ===== END RIGHT SIDE ===== */}

            </div>
          </form>
        </div>
      </div>
    </div>
  );
}